/* HOODSTARZ — Custom Interactions (vanilla, keine Abhängigkeiten) */
(() => {
  const formatMoney = (cents) =>
    new Intl.NumberFormat(document.documentElement.lang || 'de-DE', {
      style: 'currency',
      currency: window.Shopify?.currency?.active || 'EUR',
    }).format(cents / 100);

  /* ---------- Lieferdatum (PDP) ---------- */
  const addBusinessDays = (date, days) => {
    const d = new Date(date);
    let added = 0;
    while (added < days) {
      d.setDate(d.getDate() + 1);
      const day = d.getDay();
      if (day !== 0 && day !== 6) added++;
    }
    return d;
  };
  document.querySelectorAll('[data-hs-delivery]').forEach((el) => {
    const cutoff = Number(el.dataset.cutoff || 14);
    const min = Number(el.dataset.min || 1);
    const max = Number(el.dataset.max || 3);
    const now = new Date();
    const isWeekend = now.getDay() === 0 || now.getDay() === 6;
    const shipsToday = !isWeekend && now.getHours() < cutoff;
    const base = shipsToday ? now : addBusinessDays(now, 1);
    const fmt = new Intl.DateTimeFormat('de-DE', { weekday: 'short', day: '2-digit', month: '2-digit' });
    const from = fmt.format(addBusinessDays(base, min));
    const to = fmt.format(addBusinessDays(base, max));
    const dateEl = el.querySelector('[data-hs-delivery-date]');
    if (dateEl) dateEl.textContent = min === max ? from : `${from} – ${to}`;

    const cdEl = el.querySelector('[data-hs-countdown]');
    if (cdEl && shipsToday) {
      const tick = () => {
        const end = new Date();
        end.setHours(cutoff, 0, 0, 0);
        const diff = Math.max(0, end - new Date());
        const h = Math.floor(diff / 3.6e6);
        const m = Math.floor((diff % 3.6e6) / 6e4);
        cdEl.textContent = `${h} Std. ${m} Min.`;
      };
      tick();
      setInterval(tick, 30000);
      cdEl.closest('[data-hs-countdown-row]')?.removeAttribute('hidden');
    }
  });

  /* ---------- Größentabelle (Dialog) ---------- */
  document.addEventListener('click', (e) => {
    const open = e.target.closest('[data-hs-dialog-open]');
    if (open) {
      document.getElementById(open.dataset.hsDialogOpen)?.showModal();
      return;
    }
    if (e.target.closest('[data-hs-dialog-close]')) {
      e.target.closest('dialog')?.close();
      return;
    }
    if (e.target instanceof HTMLDialogElement && e.target.classList.contains('hs-sizeguide')) {
      e.target.close();
    }
  });

  /* ---------- Sticky Add-to-Cart ---------- */
  const sticky = document.querySelector('[data-hs-sticky-atc]');
  if (sticky) {
    // Nicht das erste /cart/add-Formular nehmen: Dawn rendert davor ein Ratenzahlungs-Formular ohne Button
    const mainBtn = document.querySelector('product-info product-form [type="submit"][name="add"], product-form [type="submit"]');
    const stickyBtn = sticky.querySelector('button');
    const priceEl = sticky.querySelector('[data-hs-sticky-price]');

    if (mainBtn) {
      // Scroll statt IntersectionObserver: schnelles Wischen springt sonst über den Button hinweg
      let ticking = false;
      const update = () => {
        ticking = false;
        const passed = mainBtn.getBoundingClientRect().bottom < 0;
        sticky.classList.toggle('is-visible', passed);
        sticky.setAttribute('aria-hidden', String(!passed));
      };
      window.addEventListener(
        'scroll',
        () => {
          if (!ticking) requestAnimationFrame(update);
          ticking = true;
        },
        { passive: true }
      );
      update();
      stickyBtn.addEventListener('click', () => mainBtn.click());

      const syncState = () => {
        stickyBtn.disabled = mainBtn.disabled;
        const label = mainBtn.querySelector('span')?.textContent.trim();
        if (label) stickyBtn.querySelector('span').textContent = label;
      };
      new MutationObserver(syncState).observe(mainBtn, { attributes: true, childList: true, subtree: true });
      syncState();
    }

    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.variantChange, ({ data }) => {
        if (data?.variant && priceEl) priceEl.textContent = formatMoney(data.variant.price);
      });
    }
  }

  /* ---------- Shop the Look / Komplettiere den Look: Größenwahl ---------- */
  const syncLook = (root) => {
    const ids = [];
    let complete = true;
    root.querySelectorAll('.hs-look__item').forEach((item) => {
      const sel = item.querySelector('[data-hs-look-select]');
      const btn = item.querySelector('[data-hs-add]');
      if (!btn) return;
      if (sel) btn.dataset.hsAdd = sel.value;
      if (!btn.dataset.hsAdd) complete = false;
      else ids.push(btn.dataset.hsAdd);
    });
    const all = root.querySelector('[data-hs-add-all]');
    if (all) {
      all.dataset.hsAdd = ids.join(',');
      all.disabled = !complete || ids.length === 0;
      all.textContent = complete ? 'Ganzen Look in den Warenkorb' : 'Erst Größen wählen';
    }
  };
  document.querySelectorAll('[data-hs-look]').forEach((root) => {
    root.addEventListener('change', () => syncLook(root));
    syncLook(root);
  });

  /* ---------- Direkt in den Warenkorb ---------- */
  document.addEventListener('click', async (e) => {
    const btn = e.target.closest('[data-hs-add]');
    if (!btn) return;
    e.preventDefault();
    const cartDrawer = document.querySelector('cart-drawer');
    const ids = btn.dataset.hsAdd.split(',').filter(Boolean);
    const errorEl = btn.closest('[data-hs-look]')?.querySelector('[data-hs-add-error]');
    if (ids.length === 0) {
      btn.closest('.hs-look__item')?.querySelector('[data-hs-look-select]')?.focus();
      if (errorEl) {
        errorEl.textContent = 'Bitte wähle zuerst deine Größe.';
        errorEl.hidden = false;
      }
      return;
    }
    if (errorEl) errorEl.hidden = true;
    btn.setAttribute('aria-busy', 'true');
    btn.disabled = true;
    try {
      const res = await fetch(`${window.routes?.cart_add_url || '/cart/add'}.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({
          items: ids.map((id) => ({ id: Number(id), quantity: 1 })),
          sections: cartDrawer ? cartDrawer.getSectionsToRender().map((s) => s.id) : [],
          sections_url: window.location.pathname,
        }),
      });
      const json = await res.json();
      if (!res.ok) throw new Error(json.description || 'Fehler');
      if (cartDrawer) {
        cartDrawer.classList.remove('is-empty');
        cartDrawer.renderContents(json);
      } else {
        window.location.href = window.routes?.cart_url || '/cart';
      }
    } catch (err) {
      btn.dataset.error = err.message;
      if (errorEl) {
        errorEl.textContent = err.message;
        errorEl.hidden = false;
      }
    } finally {
      btn.removeAttribute('aria-busy');
      btn.disabled = false;
      const root = btn.closest('[data-hs-look]');
      if (root) syncLook(root);
    }
  });
})();
